const currentDate = new Date();
const isoDateString = currentDate.toISOString();

export const checkActiveStatus = (
  createdDate: string,
  range: string,
  dealer?: any
) => {
  // Check if dealer is manually disabled
  const dbStatus = dealer?.status;
  const hasPassword = dealer?.password;
  
  // If dealer is disabled, always show Disabled
  if (dbStatus === "Disabled") {
    return "Disabled";
  }
  
  // If dealer is manually set to Inactive and has accepted invitation, show Inactive
  // if (dbStatus === "Inactive" && hasPassword) {
  //   return "Inactive";
  // }

  // If dealer has password, they've accepted the invitation
  const invitationSentAt = dealer?.invitation_sent_at;

  // If dealer hasn't accepted invitation yet
  if (!hasPassword && invitationSentAt) {
    // Check if invitation has expired (7 days)
    const invitationDate: any = new Date(invitationSentAt);
    const current: any = new Date();
    const daysSinceInvitation = (current - invitationDate) / (1000 * 60 * 60 * 24);

    if (daysSinceInvitation > 7) {
      return "Invite Expired";
    }
    
    return "Invite Sent";
  }

  // If no invitation sent and no password, return Inactive
  if (!hasPassword) {
    return "Inactive";
  }

  // Dealer has accepted invitation - check active/inactive status based on last_activity_date
  const current: any = new Date(isoDateString);
  // Use last_activity_date if available, otherwise fall back to created_at
  // Check multiple possible field names for last activity date
  const lastActivityDate = dealer?.last_activity_date || dealer?.last_activity || dealer?.updatedAt || createdDate;
  let activityDate: any = new Date(lastActivityDate);

  // Validate that the date was parsed correctly
  if (isNaN(activityDate.getTime())) {
    // If date parsing failed, fall back to created_at
    activityDate = new Date(createdDate);
    if (isNaN(activityDate.getTime())) {
      return "Inactive";
    }
  }

  const difference = current - activityDate;

  if (!range || range === "null" || range === "undefined") return "Inactive";

  // Parse the range string - handle formats like "1year", "1 years", "1year", etc.
  const rangeLower = String(range).toLowerCase().trim();
  const rangeValue = parseInt(rangeLower);
  
  if (isNaN(rangeValue) || rangeValue <= 0) {
    return "Inactive";
  }

  let rangeInMs;
  if (rangeLower.includes("month")) {
    rangeInMs = rangeValue * 30 * 24 * 60 * 60 * 1000; // Approximating 1 month as 30 days
  } else if (rangeLower.includes("year")) {
    rangeInMs = rangeValue * 365 * 24 * 60 * 60 * 1000; // Approximating 1 year as 365 days
  } else if (rangeLower.includes("day")) {
    rangeInMs = rangeValue * 24 * 60 * 60 * 1000; // Number of milliseconds in a day
  } else {
    return "Inactive";
  }

  // Check if last activity is within the range
  // If difference is negative (future date), treat as Active
  if (difference < 0) {
    return "Active";
  }
  
  if (difference > rangeInMs) {
    return "Inactive";
  }
  return "Active";
};